// Roles Management Permissions

export const ROLES_INDEX = 88;
export const ROLES_SHOW = ROLES_INDEX;
export const ROLES_CREATE = 89;
export const ROLES_EDIT = 90;
export const ROLES_DELETE = 91;
